import styles from './MemberCard.module.css';

function MemberCard({ name, role, image, cardRef, delay, onClick, hide, invisible, floating, startPos, expanded, closing }) {
  if (floating && startPos) {
    const isMobile = window.innerWidth <= 768;

    let expandedW, expandedH, endX, endY;

    if (isMobile) {
      expandedW = Math.min(window.innerWidth * 0.5988, 300);
      expandedH = Math.min(window.innerHeight * 0.42, 420);
      endX = window.innerWidth / 2 - expandedW / 2;
      endY = window.innerHeight * 0.18;
    } else {
      expandedW = Math.min(350, window.innerWidth * 0.28);
      expandedH = Math.min(500, window.innerHeight * 0.72);
      endX = window.innerWidth * 0.25 - expandedW / 2;
      endY = window.innerHeight / 2 - expandedH / 2 + 40;
    }

    return (
      <div
        className={`${styles.card} ${styles.floating} ${expanded ? styles.floatingExpanded : ''} ${closing ? styles.closing : ''}`}
        style={{
          '--start-x': `${startPos.x}px`,
          '--start-y': `${startPos.y}px`,
          '--start-w': `${startPos.w}px`,
          '--start-h': `${startPos.h}px`,
          '--end-x': `${endX}px`,
          '--end-y': `${endY}px`,
          '--end-w': `${expandedW}px`,
          '--end-h': `${expandedH}px`,
        }}
      >
        <img src={image} alt={name} className={styles.image} />
        <div className={styles.vignette} />
      </div>
    );
  }

  return (
    <div
      className={`
        ${styles.card}
        ${hide ? styles.hide : ''}
        ${invisible ? styles.invisible : ''}
      `}
      ref={cardRef}
      style={{ '--delay': delay }}
      onClick={onClick}
    >
      <img src={image} alt={name} className={styles.image} />
      <div className={styles.vignette} />
      <div className={styles.overlay}>
        <p className={styles.name}>{name}</p>
        <p className={styles.role}>{role}</p>
      </div>
    </div>
  );
}

export default MemberCard;